export default "__VITE_ASSET__B$GY$u8P__"